import { jsx as s } from "react/jsx-runtime";
import { U as m, d as l } from "../../vendor-Dd6qj6gJ.js";
import '../../assets/index43.css';const p = "_metricDelta_o72hu_1", _ = "_positive_o72hu_17", d = "_negative_o72hu_22", u = "_neutral_o72hu_27", e = {
  metricDelta: p,
  positive: _,
  negative: d,
  neutral: u
}, f = [0, 0.15, 0.35, 0.55, 0.75];
function b({
  value: t,
  tone: i,
  formatting: o = {
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
    signDisplay: "exceptZero",
    style: "decimal"
  },
  shade: a = 4
}) {
  const c = m(o);
  if (t == null || Number.isNaN(t))
    return null;
  const r = {
    "--metric-delta-bg-opacity": f[a]
  }, n = c.format(t);
  return /* @__PURE__ */ s(
    "data",
    {
      value: t,
      className: l(e.metricDelta, e[i]),
      "data-component": "MetricDelta",
      style: r,
      children: n
    }
  );
}
export {
  b as MetricDelta
};
